import { BrowserRouter, Route, Routes } from "react-router-dom";
import { RootLayout } from "../layout/root-layout";
import { Plan } from "../views/plan";
import { Location } from "../views/location";
import { Rsvp } from "../views/rsvp";
import { Dashboard } from "../views/dashboard/dashboard2";
import { GiftRegistry } from "../views/dashboard/giftlist";

export const AppRouter = () => (

    <BrowserRouter>
        <Routes>
            <Route path="/" element={<RootLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/rsvp" element={<Rsvp />} />
                <Route path="/plan" element={<Plan />} />
                <Route path="/gifts" element={<GiftRegistry />} />
                <Route path="/location" element={<Location />} />

            </Route>
        </Routes>
    </BrowserRouter>
)